import React from 'react';
import { faSearch } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslation } from 'react-i18next';
import Input from '@ssg/common/Components/Input';
import { CatalogContacts, GetWebCatalogCustomers_catalogCustomers } from '../../../GraphQL';
import Select from 'react-select';
import SearchableSelect from '@ssg/common/Components/SearchableSelect';
import { useForm } from 'react-hook-form';
import { SelectOption } from '@ssg/common/Helpers/Helpers';
import Pill from '@ssg/common/Components/Pill';

interface IProps {
	setFilterTerm: (v: string) => void;
	setContactType: (v: CatalogContacts | undefined) => void;
	contactType?: CatalogContacts;
	catalogCustomers: GetWebCatalogCustomers_catalogCustomers[];
	customerIds: string[] | null;
	setCustomerIds(ids: React.SetStateAction<string[] | null>): void;
	catalogCustomer: GetWebCatalogCustomers_catalogCustomers | undefined;
}

const ContactsFilter: React.FC<IProps> = ({ setFilterTerm, contactType, setContactType, catalogCustomers, customerIds, setCustomerIds, catalogCustomer }) => {
	const { t } = useTranslation();
	const dummyForm = useForm();
	const contactTypeEnum = [
		{
			label: t('catalog.contact.OPEN_CONTACTS'),
			value: CatalogContacts.OPEN_CONTACTS,
		},
		{
			label: t('catalog.contact.OPEN_CONTACTS_MAIL_CONTACTS'),
			value: CatalogContacts.OPEN_CONTACTS_MAIL_CONTACTS,
		},
		{
			label: t('catalog.contact.OPEN_CONTACTS_CLOSED_CONTACTS'),
			value: CatalogContacts.OPEN_CONTACTS_CLOSED_CONTACTS,
		},
		{
			label: t('catalog.contact.OPEN_CONTACTS_CLOSED_CONTACTS_MAIL_CONTACTS'),
			value: CatalogContacts.OPEN_CONTACTS_CLOSED_CONTACTS_MAIL_CONTACTS,
		},
		{
			label: t('catalog.contact.CLOSED_CONTACTS'),
			value: CatalogContacts.CLOSED_CONTACTS,
		},
		{
			label: t('catalog.contact.CLOSED_CONTACTS_MAIL_CONTACTS'),
			value: CatalogContacts.CLOSED_CONTACTS_MAIL_CONTACTS,
		},
		{
			label: t('catalog.contact.MAIL_CONTACTS'),
			value: CatalogContacts.MAIL_CONTACTS,
		},
	];

	const [customerSearchText, setCustomerSearchText] = React.useState('');

	const [customers, setCustomers] = React.useState<SelectOption[]>([]);
	React.useEffect(() => {
		setCustomers(catalogCustomers.filter(ct => ct.name.toLowerCase().includes(customerSearchText.toLowerCase())).map((u): SelectOption => ({ value: u.id, label: u.name })) ?? []);
	}, [catalogCustomers, customerSearchText]);
	if (typeof catalogCustomer !== 'undefined') return <div></div>;
	return (
		<div className="text-blue mx-0">
			<div className="flex w-full flex-row flex-wrap">
				<div className="mr-3">
					<label className="mb-px block text-xs font-medium" htmlFor="overview-search">
						{t('common.search')}
					</label>
					<div className="flex">
						<div className="relative w-full">
							<FontAwesomeIcon icon={faSearch} className="absolute" style={{ top: '9px', right: '8px' }} />
							<Input
								name="overview-search"
								placeholder={t('common.searchPlaceholder')}
								className="pr-8 text-sm"
								style={{ minWidth: '220px' }}
								onChange={e => setFilterTerm(e.target.value)}
							/>
						</div>
					</div>
				</div>

				<div className="mr-3">
					<label className="mb-1 block text-xs font-medium">
						{t('catalog.customer')}
						<SearchableSelect
							key="customer-filter"
							control={dummyForm.control}
							name="customerFilter"
							options={customers}
							searchFn={searchText => setCustomerSearchText(searchText)}
							onSelect={value => {
								if (value !== '') setCustomerIds(ids => [...(ids ?? []), value]);
							}}
							onBlur={clearFn => clearFn()}
							minInputLength={-1}
							isLoading={false}
							className="lg:w-full"
						/>
					</label>

					<ul className="text-xs">
						{customerIds?.map(d => (
							<li key={d}>
								<Pill onClick={() => setCustomerIds(ids => (ids ?? []).filter(id => id !== d))}>{catalogCustomers.filter(cc => cc.id === d)[0].name}</Pill>
							</li>
						))}
					</ul>
				</div>
				<div>
					<label className="text-blue mr-3 block text-xs font-medium">
						{t('common.type')}
						<Select
							placeholder=""
							isClearable
							closeMenuOnSelect={false}
							menuPortalTarget={document.body}
							className="react-select-custom w-48 text-xs"
							styles={{
								menuPortal: base => ({ ...base, zIndex: 6667 }),
								option: base => ({
									...base,
									fontSize: '0.75rem',
								}),
							}}
							onChange={option => setContactType(option?.value)}
							options={contactTypeEnum}
						/>
					</label>
				</div>
			</div>
		</div>
	);
};

export default ContactsFilter;
